const INITIAL_STATE = {
  data: {},
  errors: {}
}
		
const getRoyaltyReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ROYALTY_REPORT_SUCCESSFULLY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_ROYALTY_REPORT_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
		
export default getRoyaltyReport;